'use client';

import { m } from 'framer-motion';

import { Button, Typography } from '@mui/material';
import { CompactLayout } from '../layouts/compact';
import { MotionContainer, varBounce } from '../animate';

import ErrorIllustration from '@/assetes/illustrations/error-illustration';

export const ErrorView = () => (
  <CompactLayout>
    <MotionContainer>
      <m.div variants={varBounce().in}>
        <Typography variant="h3" sx={{ mb: 2 }}>
          Sorry, There is an error!
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <Typography sx={{ color: 'text.secondary' }}>
          We have an internal error and please kindly reload your page.
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <ErrorIllustration
          sx={{
            height: 260,
            my: { xs: 5, sm: 10 },
          }}
        />
      </m.div>

      <Button
        onClick={() => {
          window.location.reload(true);
        }}
        size="medium"
        variant="contained"
      >
        Reload
      </Button>
    </MotionContainer>
  </CompactLayout>
);
